"use strict";

import $ from 'jquery';
import swal from 'sweetalert';
import Messages from '../common/Messages';
import AccountChangeRequestService, {
    StudentAccountChangeRequest
} from '../endpoints/AccountChangeRequestService';
import Navigation from '../common/Navigation';
import { securityCode } from '../common/validators';

securityCode.addMethod();

export default {
    init : function(forgotModalSelector, clickSelector, forgoModalForHasCodeSelector) {
        const forgotPwdModal = new ForgotPasswordModal(forgotModalSelector, clickSelector);
        forgotPwdModal.init();

        this.modalForHasCode = new ForgotPasswordModalForOnLoad(forgoModalForHasCodeSelector);
        this.modalForHasCode.init();

        if (window.location.search.indexOf('forgotPassword') >= 0){
            this.modalForHasCode.show();
            window.history.replaceState({}, window.title, window.location.pathname);
        }
    }
 };

class AbstractModal {
    constructor(modalSelector) {
        this.modal = $(modalSelector);
        this.theForm = this.modal.find('form');
    }

    init(onValidated) {
        //clear specified inputs when modal is shown
        this.modal
            .off('show.bs.modal')
            .on ('show.bs.modal', () => {
            this.modal.find('label.error').remove();
            this.modal.find('.error').removeClass("error");

            this.modal.find('input:not(.no-validate)')
                .val('')
                .trigger('change');

        });
        //set first input active after opening
        this.modal
            .off('shown.bs.modal')
            .on ('shown.bs.modal', () => {
            this.modal.find('input').filter(':first').trigger('focus');
        });

        this.modal
            .off('click', '.btn-save')
            .on ('click', '.btn-save', (e) => {
            e.preventDefault();
            this.theForm.submit();
        });

        this.theForm
            .off('submit')
            .on ('submit', (e) => {
            e.preventDefault();
            if (this.theForm.valid() === true) {
                onValidated(this.theForm);
            }
        });

        this.theForm.validate();
    }
}

class ForgotPasswordModal extends AbstractModal {
    constructor(modalSelector, clickSelector) {
        super(modalSelector);
        $(clickSelector).on('click', () => this.modal.appendTo("body").modal({ 'show': true,  backdrop: 'static' }));
        let confirmModalSelector = this.modal.data('next-step-id');
        this.nextStep = new ConfirmEmailModal($(`#${confirmModalSelector}`));
    }

    init() {
        super.init((theForm) => this.continue(theForm.find(".required.email").val()));
    }

    continue(address) {
        AccountChangeRequestService.requestPasswordReset(new StudentAccountChangeRequest(address))
        .then(() => {
            this.modal.modal('hide');
            this.nextStep.init(address);
            this.nextStep.show();
        })
        .catch((error) => {
            swal({
                title: "Error",
                text: `We were unable to send your password reset code. ${Messages.CONTACT_SUPPORT}`,
                type: "error",
                confirmButtonText: "Ok" });
        });
        return this.nextStep;
    }
}

class ForgotPasswordModalForOnLoad extends AbstractModal {
    constructor(modalSelector) {
        super(modalSelector);
        let confirmModalSelector = this.modal.data('next-step-id');
        this.nextStep = new ConfirmEmailModal($(`#${confirmModalSelector}`));
    }

    init() {
        super.init((theForm) => this.continue(theForm.find(".required.email").val()));
    }

    show() {
        this.modal.appendTo("body").modal({ 'show': true,  backdrop: 'static' });
    }

    continue(address) {

        this.modal.modal('hide');
        this.nextStep.init(address);
        this.nextStep.show();

        return this.nextStep;
    }
}

class ConfirmEmailModal extends AbstractModal {
    constructor(modalSelector) {
        super(modalSelector);
        let changeModalSelector = this.modal.data('next-step-id');
        this.nextStep = new ChangePasswordModal($(`#${changeModalSelector}`));
    }

    continue(address, code) {
        this.nextStep.init(address, code);
        this.next();

        return this.nextStep;
    }

    init(email) {
        let emailText = this.modal.find('#replace-email-text');
        if (emailText) { emailText.text(emailText.text().replace('{{{email}}}', email)); }

        super.init((theForm) => {
            let verificationCode = theForm.find("#confirm-email-verification-code").val();
            this.continue(email, verificationCode);
        });

        this.theForm.find('#confirm-email-modal-emailAddress').val(email);
    }

    show() {
        this.modal.appendTo("body").modal('show');
    }

    next() {
        this.modal.modal('hide');
        this.nextStep.show();
    }
}

class ChangePasswordModal extends AbstractModal {
    constructor(modalSelector) {
        super(modalSelector);
    }

    continue(email, securityCode, newPassword) {
        let change = {email, securityCode, newPassword};
        AccountChangeRequestService.performChange(change)
        .then(() => Navigation.goto('dashboard?passwordChanged'))
        .catch((error) => {
            swal({
                title: "Error",
                text: `We were unable to change your password. ${Messages.CONTACT_SUPPORT}`,
                type: "error",
                confirmButtonText: "Ok" });
        });
    }

    init(email, code) {
        this.theForm.validate({
              rules: {
                  'edit-password-confirm' : {
                      'equalTo': '#edit-password'
                  }
              },
              messages : {
                  'edit-password-confirm' : {
                      'equalTo': 'passwords must match'
                  }
              }
        });
        super.init((theForm) => {
            let newPassword = theForm.find("#edit-password").val();
            this.continue(email, code, newPassword);
        });
    }

    show() {
        this.modal.appendTo("body").modal('show');
    }
}



// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/index/forgot-password.js